<template>
  <div class="full-f-chart wirelessmap-wrapper" v-loading="loading">
    <div class="search-area">
      <el-input class="search-input mr-r4" size="mini" v-model="searchKeyword" clearable placeholder="검색 키워드를 입력해주십시오."
        style="width: 210px" @keyup.enter.native="searchNode" @clear="searchNode">
        <i class="el-input__icon far fa-search" slot="suffix" style="cursor: pointer" @click="searchNode"></i>
      </el-input>
      <el-popover width="370" placement="bottom-start" trigger="click" @after-leave="onFilterPopoverLeave">
        <el-button slot="reference" :type="isFilterActive ? 'primary' : 'default'" style="box-shadow:rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;">
          <i class="fas fa-filter" />
        </el-button>
        <div style="padding: 5px">
          <el-row v-show="selectedNode.obj && selectedNode.obj.objtypeId === 'AP_CONTROLLER'">
            <el-form :model="wirelessapFilterInfo" :inline="true" label-width="92px" label-position="left">
              <el-form-item>
                <el-checkbox slot="label" v-model="wirelessapFilterInfo.active">AP</el-checkbox>
                <el-select v-model="wirelessapFilterInfo.traffic" style="width: 110px">
                  <el-option label="트래픽 IN" value="trafficIn"></el-option>
                  <el-option label="트래픽 OUT" value="trafficOut">트래픽 OUT</el-option>
                </el-select>
                <el-select v-model="wirelessapFilterInfo.align" style="width: 90px">
                  <el-option label="Top" value="DESC"></el-option>
                  <el-option label="Bottom" value="ASC"></el-option>
                </el-select>
                <el-select v-model="wirelessapFilterInfo.limit" style="width: 60px">
                  <el-option label="5" value="5"></el-option>
                  <el-option label="10" value="10"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-row>
          <el-row v-show="selectedNode.obj && selectedNode.obj.objtypeId === 'WIRELESSAP'">
            <el-form :model="clientFilterInfo" :inline="true" label-width="92px" label-position="left">
              <el-form-item>
                <el-checkbox slot="label" v-model="clientFilterInfo.active">접속자</el-checkbox>
                <el-select v-model="clientFilterInfo.traffic" style="width: 110px">
                  <el-option label="트래픽 IN" value="trafficIn"></el-option>
                  <el-option label="트래픽 OUT" value="trafficOut">트래픽 OUT</el-option>
                </el-select>
                <el-select v-model="clientFilterInfo.align" style="width: 90px">
                  <el-option label="Top" value="DESC"></el-option>
                  <el-option label="Bottom" value="ASC"></el-option>
                </el-select>
                <el-select v-model="clientFilterInfo.limit" style="width: 60px">
                  <el-option label="5" value="5"></el-option>
                  <el-option label="10" value="10"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-row>
          <el-row v-show="selectedNode.obj && selectedNode.obj.objtypeId === 'AP_CONTROLLER'">
            <el-form :model="eventlevelFilterInfo" :inline="true" label-width="92px" label-position="left">
              <el-form-item>
                <el-checkbox slot="label" v-model="eventlevelFilterInfo.active">이벤트등급</el-checkbox>
                <el-select v-model="eventlevelFilterInfo.eventlevelIds" multiple style="width: 265px" ref="eventlevelSelect">
                  <el-option v-for="event in eventlevelInfo" :key="event.eventlevelId" :label="event.eventlevelName" :value="event.eventlevelId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-row>
        </div>
      </el-popover>
      <span class="filter-info mr-l4" v-show="isFilterActive">
        <span v-for="item in filterLabel" :key="item.key" class="item">
          <span class="tit label">{{ item.label }}</span>
          <span class="value">{{ item.value }}</span>
        </span>
      </span>
    </div>
    <div class="btn-list">
      <el-button size="mini" @click="onZoom('zoomIn')">
        <i class="far fa-plus" style="font-size: 14px;"></i>
      </el-button>
      <el-button size="mini" @click="onZoom('zoomOut')">
        <i class="far fa-minus" style="font-size: 14px;"></i>
      </el-button>
      <el-button size="mini" @click="onZoom('zoomInit')">
        <i class="far fa-sync-alt" style="font-size: 14px;"></i>
      </el-button>
    </div>
    <div style="height:100%; width:100%; z-index: 0; display: flex; align-items: center; justify-content: center; transform-origin: 50% 50%">
      <svg ref="svg" class="wirelessmap-svg" width="960" height="900" />
      <div class="wirelessmap-tooltip" :style="{ borderLeftColor: setEventlevelColorBg(tooltip.eventlevelId, CIRCLE_DEFAULT_STROKE_COLOR) }">
        <div>
          <span class="mr-r4" style="font-weight: bold">{{ tooltip.label }}</span>
          <span class="info-text">{{ tooltip.ipaddress }}</span>
        </div>
        <div>
          <span class="tit label">트래픽 IN/OUT:</span><span class="value">{{ `${tooltip.trafficInValue} / ${tooltip.trafficOutValue}` }}</span>
        </div>
        <div v-show="tooltip.targeType !== 'CLIENT'">
          <span class="tit label">이벤트:</span><span class="value">{{ tooltip.eventLabel }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3';
import { isNil, isEmpty, cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT } from '@/utils/string';
import { getClientName } from '@/utils/wireless-device';
import api from '@/api/performance/wireless-device-map/wireless-device-map';

export default {
  name: 'WWirelessMapView',
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      CIRCLE_DEFAULT_STROKE_COLOR: '#c5c5c5',
      loading: false,
      wirelessMapData: {},
      width: 960,
      height: 900,
      root: null,
      nodes: [],
      links: [],
      textElements: [],
      /* zoom */
      zoomHandler: null,
      zoom: {
        x: 0, // Translate를 위한 X좌표 초기값
        y: 0, // Translate를 위한 Y좌표 초기값
        k: 1, // Scale 초기값
      },
      /* tooltip */
      tooltip: {},
      iconUnicode: {
        AP_CONTROLLER: '\uf0a0',
        WIRELESSAP: '\uf1eb',
        CLIENT: '\uf007',
      },
      adjlist: [],
      /* 검색 필터 */
      searchKeyword: '',
      isFilterActive: false,
      wirelessapFilterInfo: {
        active: false,
        traffic: 'trafficIn',
        align: 'DESC',
        limit: '5',
      },
      clientFilterInfo: {
        active: false,
        traffic: 'trafficIn',
        align: 'DESC',
        limit: '5',
      },
      filterLabel: [],
      eventlevelFilterInfo: { active: false },
      sortedWirelessapDatas: { trafficIn: [], trafficOut: [] },
      sortedClientDatas: { trafficIn: [], trafficOut: [] },
      showTopNFlag: false,
      selectedMapNode: null,
      isLoadedNodes: [],
      nodeCount: {},
    };
  },
  computed: {
    eventlevelInfo() {
      return this.$store.getters.eventlevelInfo;
    },
    ...mapGetters(['selectedNode']),
  },
  watch: {
    active(value) {
      if (value) {
        this.initMap();
      }
    },
    selectedNode: {
      // immediate: true,
      handler(to, from) {
        if (this.active && to.treeKey !== from.treeKey) {
          this.initMap();
        }
      },
    },
    isFilterActive(value) {
      if (!value) {
        this.wirelessapFilterInfo = { active: false, traffic: 'trafficIn', align: 'DESC', limit: '5' };
        this.clientFilterInfo = { active: false, traffic: 'trafficIn', align: 'DESC', limit: '5' };
        this.eventlevelFilterInfo = { active: false };
      }
    },
  },
  methods: {
    /**
     * 무선 장비 맵 초기화
     * @author jeee12
     */
    initMap() {
      this.searchKeyword = '';
      this.zoom = {
        x: 0,
        y: 0,
        k: 1,
      };
      this.showTopNFlag = false;
      this.isFilterActive = false;
      this.wirelessapFilterInfo = { active: false, traffic: 'trafficIn', align: 'DESC', limit: '5' };
      this.clientFilterInfo = { active: false, traffic: 'trafficIn', align: 'DESC', limit: '5' };
      this.eventlevelFilterInfo = { active: false };
      this.selectedMapNode = null;
      this.nodeCount = {};

      this.removeMap();
      this.loadData();
    },
    /**
     * 맵 elements 제거
     * @author jeee12
     */
    removeMap() {
      const svg = d3.select('.wirelessmap-svg');
      svg.selectAll('*').remove();
    },
    /**
     * radial tree 계층 구조 생성 (depth별 노드 최대 갯수를 기준으로 원 크기 설정)
     * @author jeee12
     * @param  {[type]} treeData [description]
     */
    setHierarchyTree(treeData) {
      const nodeCount = Math.max.apply(null, Object.values(this.nodeCount));
      const maxNodeDetph = Object.keys(this.nodeCount).find((key) => this.nodeCount[key] === nodeCount);
      const svg = d3.select('.wirelessmap-svg');
      const diameter = +svg.attr('width') + nodeCount;
      let width = 360;
      if (nodeCount <= 10) {
        width /= 3;
      } else if (nodeCount < 100) {
        if (maxNodeDetph < 2) {
          width = (width / 2) + (nodeCount * 2);
        } else {
          width = (width / 3) + (nodeCount * 2);
        }
      }
      return d3.tree()
        .size([width, (diameter / 2) - 120])
        .separation((a, b) => (a.parent === b.parent ? 1 : 1.5) / a.depth)(treeData);
    },
    /**
     * 무선 장비 맵 데이터 로드
     * @author jeee12
     */
    loadData(selectTarget) {
      // api 호출
      this.loading = true;
      const objtypeId = this.selectedNode.obj.objtypeId;
      if (objtypeId === 'AP_CONTROLLER' && isNil(selectTarget)) {
        api.getApControllerMapData({
          // 장비 맵의 root objId
          parentObjId: this.selectedNode.obj.objId,
        }).then((response) => {
          if (response.data.success) {
            this.wirelessMapData = cloneDeep(response.data.data);
            const wirelessapDatas = [];
            this.wirelessMapData.children.forEach((data) => {
              wirelessapDatas.push(data);
            });
            const sortWirelessapFunc = (list, trafficFlag) => ( // 무선 AP 트래픽 IN/OUT 내림차순 정렬
              list.sort((a, b) => {
                if (isNil(a[trafficFlag]) || isNil(a[trafficFlag].rscValue)) {
                  return 1;
                } else if (isNil(b[trafficFlag]) || isNil(b[trafficFlag].rscValue)) {
                  return -1;
                } else if (a[trafficFlag] > b[trafficFlag]) {
                  return -1;
                }
                return a[trafficFlag] < b[trafficFlag] ? 1 : 0;
              }).filter((data) => !isNil(data[trafficFlag]) && !isNil(data[trafficFlag].rscValue))
            );
            this.sortedWirelessapDatas.trafficIn = sortWirelessapFunc(wirelessapDatas, 'trafficInRscInfo').map((e) => e.treeKey);
            this.sortedWirelessapDatas.trafficOut = sortWirelessapFunc(wirelessapDatas, 'trafficOutRscInfo').map((e) => e.treeKey);

            this.isLoadedNodes = []; // 무선 AP 하위 접속자 정보의 로드 여부 판단을 위한 isLoadedNodes 리스트 초기화
            this.setLayout(this.wirelessMapData.treeKey);
          }
        }).finally(() => {
          this.loading = false;
          this.clickNode(this.root);
        });
      } else if (objtypeId === 'WIRELESSAP' || (objtypeId === 'AP_CONTROLLER' && !isNil(selectTarget))) {
        let parentObjId;
        if (isNil(selectTarget)) {
          parentObjId = this.selectedNode.obj.objId;
        } else {
          parentObjId = selectTarget.data.objId;
        }

        api.getWirelessApMapData({
          // 장비 맵의 root objId
          parentObjId,
        }).then((response) => {
          if (response.data.success) {
            // 클릭한 무선ap 노드
            const targetNodeData = response.data.data;
            if (isNil(selectTarget)) {
              // 무선 AP 레벨
              const clientDatas = [];
              targetNodeData.children.forEach((data) => {
                clientDatas.push(data);
              });
              const sortClientFunc = (list, trafficFlag) => ( // 접속자 트래픽 IN/OUT 내림차순 정렬
                clientDatas.sort((a, b) => {
                  if (isNil(a.clientInfo[trafficFlag]) || isNil(b.clientInfo[trafficFlag])) {
                    return isNil(a.clientInfo[trafficFlag]) ? 1 : -1;
                  } else if (a.clientInfo[trafficFlag] > b.clientInfo[trafficFlag]) {
                    return -1;
                  }
                  return a.clientInfo[trafficFlag] < b.clientInfo[trafficFlag] ? 1 : 0;
                }).filter((data) => !isNil(data.clientInfo[trafficFlag]))
              );
              this.sortedClientDatas.trafficIn = sortClientFunc(clientDatas, 'trafficBpsIn').map((e) => e.treeKey);
              this.sortedClientDatas.trafficOut = sortClientFunc(clientDatas, 'trafficBpsOut').map((e) => e.treeKey);

              this.wirelessMapData = cloneDeep(targetNodeData);
              this.isLoadedNodes = []; // 무선 AP 하위 접속자 정보의 로드 여부 판단을 위한 isLoadedNodes 리스트 초기화
              this.setLayout(this.wirelessMapData.treeKey);
            } else {
              // AP 컨트롤러 > 무선 AP > 클라이언트 표현 시, 기존에 그려진 layout은 유지
              const treeKey = targetNodeData.treeKey;
              const findChildFunc = (node) => {
                if (node.type === 'WIRELESSAP' && node.treeKey === treeKey) {
                  node.children = cloneDeep(targetNodeData.children);
                  this.isLoadedNodes.push(node.treeKey);
                } else if (node.type !== 'CLIENT') {
                  node.children.forEach((childNode) => findChildFunc(childNode));
                }
              };

              if (treeKey === selectTarget.data.treeKey) {
                findChildFunc(this.wirelessMapData);
                this.setRootNode(false);

                this.drawMap(this.root);
                this.setViewLayout(d3.select('.wirelessmap-svg'), d3.select('.wirelessmap-svg > g'));
              }
            }
          }
        }).finally(() => {
          this.loading = false;
          if (objtypeId === 'WIRELESSAP') {
            this.clickNode(this.root);
          }
        });
      }
    },
    /**
     * zoom in / zoom out 이벤트
     * @author jeee12
     * @param  {[type]} zoomType [description]
     * @return {[type]}          [description]
     */
    onZoom(zoomType) {
      const svg = d3.select('.wirelessmap-svg');
      if (zoomType === 'zoomIn') {
        this.zoomHandler.scaleBy(svg.transition(), 1.2);
      } else if (zoomType === 'zoomOut') {
        this.zoomHandler.scaleBy(svg.transition(), 0.8);
      } else if (zoomType === 'zoomInit') {
        if (!isNil(this.zoomHandler)) {
          this.zoomHandler.transform(svg, d3.zoomIdentity);
        }
        svg.selectAll('*').remove();
        this.isFilterActive = false;
        this.loadData();
      }
    },
    /**
     * 무선 장비 맵 초기 treedata, map, layout 생성
     * @author jeee12
     * @param  {[type]} treeKey [description]
     */
    setLayout(treeKey) {
      if (this.selectedNode.obj.objId !== Number(treeKey)) { // laod 시점 문제 해결
        return;
      }
      const svg = d3.select('.wirelessmap-svg')
        .style('width', '100%')
        .style('height', '100%')
        .style('padding', '10px')
        .style('box-sizing', 'border-box');

      const svgWidth = svg.style('width');
      const svgHeight = svg.style('height');
      let width = Number(svgWidth.substring(0, svgWidth.length - 2));
      let height = Number(svgHeight.substring(0, svgHeight.length - 2));
      if (width <= 10 && height <= 10) {
        width = window.innerWidth - (window.innerWidth / 5);
        height = window.innerHeight - (window.innerHeight / 5);
      }
      this.width = width;
      this.height = height;

      const container = svg.append('g')
        .style('transform-origin', '0 0')
        .attr('transform', `translate(${this.zoom.x},${this.zoom.y})scale(${this.zoom.k})`);

      this.links = container.append('g')
        .attr('fill', 'none')
        .attr('stroke', '#555')
        .attr('stroke-opacity', 0.4)
        .attr('stroke-width', 1.5);
      this.nodes = container.append('g')
        .attr('cursor', 'pointer')
        .attr('pointer-events', 'all');

      this.setRootNode(true);

      this.drawMap(this.root);
      this.setViewLayout(svg, container);
    },
    /**
     * 조회 데이터를 트리 계층 구조 형태로 설정, 트리의 root 노드 생성
     * @author jeee12
     * @param  {[type]} collapsedChildrenFlag depth 2이상 하위 노드 숨김 여부
     */
    setRootNode(collapsedChildrenFlag) {
      this.root = d3.hierarchy(this.wirelessMapData);
      this.nodeCount = {};
      this.root.descendants().forEach((d, i) => {
        d.id = i;
        this.nodeCount[d.depth] = !isNil(this.nodeCount[d.depth]) ? this.nodeCount[d.depth] + 1 : 1;
        d.collapsedChildren = d.children;
        if (collapsedChildrenFlag && d.depth > 0 && d.children) {
          d.children = null;
        }
      });
      this.root.x0 = this.height / 2;
      this.root.y0 = 0;
    },
    /**
     * 무선 장비 맵 생성
     * @author jeee12
     */
    drawMap(source) {
      const me = this;
      // 트리 속성
      const root = this.root;
      this.setHierarchyTree(root);
      const nodes = root.descendants();

      let left = root;
      let right = root;
      root.eachBefore((node) => {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
      });

      const project = (x, y) => {
        const angle = ((x - 90) / 180) * Math.PI;
        const radius = y;
        return [radius * Math.cos(angle), radius * Math.sin(angle)];
      };
      const diagonal = (d) => (
        `M${project(d.x, d.y)}
          C${project(d.x, (d.y + d.parent.y) / 2)}
           ${project(d.parent.x, (d.y + d.parent.y) / 2)}
           ${project(d.parent.x, d.parent.y)}`
      );

      nodes.forEach((d) => {
        // 대량의 무선 ap 및 접속자 노드 표현을 위해 nodeCount 활용
        if (d.depth < 2 && this.nodeCount[d.depth] > 20) {
          d.y = d.depth * this.nodeCount[d.depth] * 10;
        } else if (d.depth === 2 && this.nodeCount[d.parent.depth] > 20) {
          d.y = d.depth * this.nodeCount[d.parent.depth] * 15;
        } else {
          d.y = d.depth * 200;
        }
      });

      const node = this.nodes.selectAll('g.node')
        .data(nodes, (d) => d.id);
      const tooltipDiv = d3.select('.wirelessmap-tooltip').style('visibility', 'hidden');

      const nodeEnter = node
        .enter()
        .append('g')
        .attr('class', 'node c-pointer')
        .attr('transform', () => (`translate(${project(source.x0, source.y0)})`))
        .attr('fill-opacity', 0)
        .attr('stroke-opacity', 0)
        .on('click', (d) => me.clickNode(d))
        .on('dblclick', (d) => {
          if (d.data.type === 'WIRELESSAP' && me.isLoadedNodes.indexOf(d.data.treeKey) === -1) {
            // 무선 AP 최초 클릭 시에만 하위 client 정보를 load한다.
            me.currentMapNode = d;
            me.loadData(d);
          } else {
            d.children = d.children ? null : d.collapsedChildren;
            me.drawMap(d);
          }
        })
        .on('mouseover', (d) => me.mouseoverNode(d, tooltipDiv, false))
        .on('mouseout', () => me.mouseoutNode(tooltipDiv, false))
        .classed('element--active', (d) => (this.isFilterActive ? !isNil(d.isHighlighted) && d.isHighlighted : true))
        .classed('element--inactive', (d) => (this.isFilterActive ? isNil(d.isHighlighted) || !d.isHighlighted : false))
        .style('cursor', 'pointer');


      nodeEnter.append('circle')
        .attr('fill', (d) => (this.setEventlevelColorBg(d.data.eventlevelId, 'white')))
        .attr('stroke', (d) => (this.setEventlevelColorBg(d.data.eventlevelId, this.CIRCLE_DEFAULT_STROKE_COLOR)))
        .attr('r', (d) => {
          const r = 20;
          if (d.data.type === 'CLIENT' && this.nodeCount[d.depth] > 100) {
            return r / 2;
          }
          return r;
        })
        .attr('class', (d) => `circleItem-${d.id}`);

      // 노드 내부에 아이콘 배치
      nodeEnter.append('text')
        .attr('dy', '0.35em')
        .attr('text-anchor', 'middle')
        .attr('class', 'fa')
        .style('font-size', (d) => {
          const size = 20;
          if (d.data.type === 'CLIENT' && this.nodeCount[d.depth] > 100) {
            return `${size / 2}px`;
          }
          return `${size}px`;
        })
        .text((d) => this.iconUnicode[d.data.type])
        .clone(true);

      this.textElements = nodeEnter.append('text')
        .attr('class', 'text')
        .attr('dy', '0.31em')
        .attr('x', (d) => (((d.x < 180) === (!d.children)) ? 25 : -25))
        .attr('text-anchor', (d) => (((d.x < 180) === (!d.children)) ? 'start' : 'end'))
        .attr('transform', ((d) => {
          if ((d.data.type === 'WIRELESSAP' && d.depth !== 0) || d.data.type === 'CLIENT') {
            return `rotate(${(d.x < 180) ? (d.x - 90) : (d.x + 90)})`;
          }
          return '';
        }))
        .classed('element--active', (d) => (this.isFilterActive ? !isNil(d.isHighlighted) && d.isHighlighted : true))
        .classed('element--inactive', (d) => (this.isFilterActive ? isNil(d.isHighlighted) || !d.isHighlighted : false))
        .text((d) => {
          if (d.data.type === 'CLIENT') {
            return getClientName(d.data.label, d.data.clientInfo.ipAddress);
          }
          return d.data.label;
        })
        .each(function(d) {
          d.textLength = this.getComputedTextLength();
        });

      nodeEnter.append('text')
        .attr('class', 'text-topn')
        .attr('fill', 'red')
        .attr('dy', '0.31em')
        .attr('x', (d) => {
          if ((d.x < 180) === (!d.children)) {
            return d.textLength > 0 ? d.textLength + 30 : 5;
          }
          return d.textLength > 0 ? (d.textLength * (-1)) - 30 : -5;
        })
        .attr('text-anchor', (d) => (((d.x < 180) === (!d.children)) ? 'start' : 'end'))
        .attr('transform', ((d) => {
          if ((d.data.type === 'WIRELESSAP' && d.depth !== 0) || d.data.type === 'CLIENT') {
            return `rotate(${(d.x < 180) ? (d.x - 90) : (d.x + 90)})`;
          }
          return '';
        }));

      const nodeUpdate = node.merge(nodeEnter)
        .attr('fill-opacity', 1)
        .attr('stroke-opacity', 1)
        .attr('transform', (d) => (`translate(${project(d.x, d.y)})`));

      nodeUpdate.select('circle')
        .attr('r', (d) => {
          const r = 20;
          if (d.data.type === 'CLIENT' && this.nodeCount[d.depth] > 100) {
            return r / 2;
          }
          return r;
        });

      nodeUpdate.select('.text')
        .attr('x', (d) => (((d.x < 180) === (!d.children)) ? 25 : -25))
        .attr('text-anchor', (d) => (((d.x < 180) === (!d.children)) ? 'start' : 'end'))
        .attr('transform', ((d) => {
          if ((d.data.type === 'WIRELESSAP' && d.depth !== 0) || d.data.type === 'CLIENT') {
            return `rotate(${(d.x < 180) ? (d.x - 90) : (d.x + 90)})`;
          }
          return '';
        }))
        .each(function(d) {
          d.textLength = this.getComputedTextLength();
        });

      nodeUpdate.select('.text-topn')
        .attr('x', (d) => {
          if ((d.x < 180) === (!d.children)) {
            return d.textLength > 0 ? d.textLength + 30 : 5;
          }
          return d.textLength > 0 ? (d.textLength * (-1)) - 30 : -5;
        })
        .attr('text-anchor', (d) => (((d.x < 180) === (!d.children)) ? 'start' : 'end'))
        .attr('transform', ((d) => {
          if ((d.data.type === 'WIRELESSAP' && d.depth !== 0) || d.data.type === 'CLIENT') {
            return `rotate(${(d.x < 180) ? (d.x - 90) : (d.x + 90)})`;
          }
          return '';
        }));

      const nodeExit = node.exit()
        .attr('fill-opacity', 0)
        .attr('stroke-opacity', 0)
        .attr('transform', () => (`translate(${source.x},${source.y})`))
        .remove();

      nodeExit.select('circle')
        .attr('r', 1e-6);

      nodeExit.select('text')
        .style('fill-opacity', 1e-6);

      const link = this.links.selectAll('path.link')
        .data(root.descendants().slice(1), (d) => d.id);

      const linkEnter = link
        .enter()
        .append('path')
        .attr('class', 'link')
        .attr('d', diagonal)
        .classed('element--active', (d) => (this.isFilterActive ? !isNil(d.isHighlighted) && d.isHighlighted : true))
        .classed('element--inactive', (d) => (this.isFilterActive ? isNil(d.isHighlighted) || !d.isHighlighted : false));

      link.merge(linkEnter)
        .attr('d', diagonal);

      link.exit()
        .attr('d', diagonal)
        .remove();

      nodes.forEach((d) => {
        d.x0 = d.x;
        d.y0 = d.y;
      });

      this.adjlist = []; // 링크로 연결된 노드들의 연관 관계 저장
      root.links().forEach((d) => {
        this.adjlist[`${d.source.id}-${d.target.id}`] = true;
        this.adjlist[`${d.target.id}-${d.source.id}`] = true;
      });
    },
    /**
     * 초기 레이아웃 설정 (zoom handler, svg의 viewBox)
     * @author jeee12
     * @param  {[type]} svg       [description]
     * @param  {[type]} container [description]
     */
    setViewLayout(svg, container) {
      this.zoomHandler = d3.zoom()
        .scaleExtent([0.1, 4])
        .on('zoom', () => {
          this.zoom = { x: d3.event.transform.x, y: d3.event.transform.y, k: d3.event.transform.k };
          container.attr('transform', d3.event.transform);
        });
      svg.call(this.zoomHandler);

      svg
        .attr('viewBox', () => [(-this.width / 2), (-this.height / 2), this.width, this.height])
        // {
        // const { x, y, width, height } = container.node().getBBox();
        // 상단바 영역만큼 y, height 조절
        // return [x, y - 50, width, height + 55];
        // return [(-this.width / 2), (-this.height / 2), this.width, this.height];
        // })
        .on('dblclick.zoom', null);
    },
    /**
     * 맵 노드 mouseover
     * @author jeee12
     * @param  {[type]} target         [description]
     * @param  {[type]} tooltipDiv     [description]
     * @param  {[type]} showHighlights [description]
     * @return {[type]}                [description]
     */
    mouseoverNode(target, tooltipDiv, showHighlights) {
      const circle = document.getElementsByClassName(`circleItem-${target.id}`)[0];
      const coords = circle.getBoundingClientRect();
      tooltipDiv.style('left', `${coords.left / 2}px`).style('top', `${coords.top - 150}px`);
      tooltipDiv.transition().duration(200).style('visibility', 'visible');

      // tooltip 라벨 설정
      this.tooltip = {};
      const targetData = target.data;
      const trafficIn = targetData.type !== 'CLIENT' ? targetData.trafficInRscInfo : { rscValue: targetData.clientInfo.trafficBpsIn, rscUnit: 'bps' };
      const trafficOut = targetData.type !== 'CLIENT' ? targetData.trafficOutRscInfo : { rscValue: targetData.clientInfo.trafficBpsOut, rscUnit: 'bps' };
      this.tooltip = {
        targeType: targetData.type,
        label: targetData.type !== 'CLIENT' ? targetData.label : getClientName(targetData.label, targetData.clientInfo.ipAddress),
        ipaddress: targetData.type !== 'CLIENT' ? targetData.ipaddress : targetData.clientInfo.macAddress,
        trafficInValue: `${this.convertValueByUnit(trafficIn)}`,
        trafficOutValue: `${this.convertValueByUnit(trafficOut)}`,
        eventLabel: targetData.eventCount > 0 ? `${targetData.eventCount}건 발생` : '없음',
        eventlevelId: targetData.eventlevelId,
      };
      if (!showHighlights) {
        // highlight 표현
        const id = d3.select(d3.event.target).datum().id;
        d3.selectAll('.node')
          .classed('element--active', (o) => this.isLinked(id, o.id))
          .classed('element--inactive', (o) => !this.isLinked(id, o.id));
        d3.selectAll('.text')
          .classed('element--active', (o) => this.isLinked(id, o.id))
          .classed('element--inactive', (o) => !this.isLinked(id, o.id));
        d3.selectAll('path.link')
          .classed('element--active', (o) => o.id === id || o.parent.id === id)
          .classed('element--inactive', (o) => o.id !== id && o.parent.id !== id);
      }
    },
    /**
     * 맵 노드 mouseout
     * @author jeee12
     * @param  {[type]} tooltipDiv     [description]
     * @param  {[type]} showHighlights [description]
     * @return {[type]}                [description]
     */
    mouseoutNode(tooltipDiv, showHighlights) {
      tooltipDiv.transition().duration(500).style('visibility', 'hidden');
      if (!showHighlights) {
        // highlight 표현
        d3.selectAll('.node')
          .classed('element--inactive', false)
          .classed('element--active', true);
        d3.selectAll('.text')
          .classed('element--inactive', false)
          .classed('element--active', true);
        d3.selectAll('path.link')
          .classed('element--inactive', false)
          .classed('element--active', true);
      }
    },
    /**
     * 맵 노드 click (선택된 노드 강조, 검색 필터 하이라이트 유지, selectedMapNode emit)
     * @author jeee12
     * @param  {[type]} target [description]
     * @return {[type]}        [description]
     */
    clickNode(target) {
      if (d3.event && d3.event.defaultPrevented) return;

      const circles = this.nodes.selectAll('circle');
      circles.style('stroke', (d) => (d.id === target.id ? this.setEventlevelColorBg(target.data.eventlevelId, this.CIRCLE_DEFAULT_STROKE_COLOR) : this.CIRCLE_DEFAULT_STROKE_COLOR));
      circles.style('stroke-width', (d) => {
        if (d.id !== target.id) return '1px';
        return d.data.type === 'CLIENT' && this.nodeCount[d.depth] > 100 ? '7px' : '10px';
      });
      circles.style('stroke-opacity', (d) => (d.id === target.id ? 0.5 : 1));
      if (!this.selectedMapNode || this.selectedMapNode.data.treeKey !== target.data.treeKey) {
        // zoom의 새로고침으로 맵 초기화 시, 선택된 노드가 존재하면 하이라이트만 유지하도록 한다. (장비 상세 정보 데이터의 불필요한 로드 막기 위해)
        this.selectedMapNode = cloneDeep(target);
        this.$emit('node-click', this.selectedMapNode.data);
      }
    },
    /**
     * 노드 간의 연결 관계 체크
     * @author jeee12
     * @param  {[type]}  a [description]
     * @param  {[type]}  b [description]
     * @return {Boolean}   [description]
     */
    isLinked(a, b) {
      return a === b || this.adjlist[`${a}-${b}`];
    },
    setEventlevelColorBg(eventlevelId, defaultColor) {
      if (isNil(eventlevelId) || isNil(this.eventlevelInfo)) {
        return defaultColor;
      }
      return this.eventlevelInfo[eventlevelId].eventlevelColorBg;
    },
    convertValueByUnit(rscInfo) {
      if (isNil(rscInfo)) {
        return EMPTY_TEXT;
      }
      return convertValuByUnit(rscInfo.rscValue, rscInfo.rscUnit, true, true, false, true);
    },
    /**
     * 검색어에 일치하는 무선 장비 맵 노드 표현
     * @author jeee12
     * @return {[type]} [description]
     */
    searchNode() {
      const filterParams = this.getFilterParams();
      this.highlightFilteredNodes(filterParams);
    },
    /**
     * 노드 필터 조건 설정 popover 종료 이벤트
     * @author jeee12
     * @return {[type]} [description]
     */
    onFilterPopoverLeave() {
      this.$refs.eventlevelSelect.blur();

      const filterParams = this.getFilterParams();
      this.isFilterActive = !isEmpty(filterParams);
      this.highlightFilteredNodes(filterParams);
    },
    /**
     * 검색어, 필터 조건에 의해 필터링된 노드만 highlight 표현되도록 처리
     * @author jeee12
     * @param  {[type]} filterParams [description]
     * @return {[type]}              [description]
     */
    highlightFilteredNodes(filterParams) {
      const tooltipDiv = d3.select('.wirelessmap-tooltip').style('visibility', 'hidden');
      const searchKeywordLower = this.searchKeyword.toLowerCase();
      this.showTopNFlag = false;

      if (searchKeywordLower === '' && isEmpty(filterParams)) {
        // 모든 검색 조건 비었을 경우
        d3.selectAll('.node')
          .classed('element--inactive', false)
          .classed('element--active', true)
          .on('mouseover', (d) => this.mouseoverNode(d, tooltipDiv, false))
          .on('mouseout', () => this.mouseoutNode(tooltipDiv, false));
        d3.selectAll('.text')
          .classed('element--inactive', false)
          .classed('element--active', true);
        d3.selectAll('.text-topn')
          .classed('text-topn--inactive', true)
          .classed('text-topn--active', false);
        d3.selectAll('path.link')
          .classed('element--inactive', false)
          .classed('element--active', true);
      } else {
        // 검색 키워드, 검색 필터
        const filterFunc = (node) => {
          let searchMatched = false;
          let wirelessapMatched = false;
          let clientMatched = false;
          let eventlevelMatched = false;

          const data = node.data;
          let topNData = null;
          if (searchKeywordLower !== '') {
            if (data.type === 'AP_CONTROLLER' || data.type === 'WIRELESSAP') {
              searchMatched = data.objName.toLowerCase().indexOf(searchKeywordLower) > -1 || data.ipaddress.toLowerCase().indexOf(searchKeywordLower) > -1;
            } else {
              const clientInfo = data.clientInfo;
              searchMatched = clientInfo.clientName.toLowerCase().indexOf(searchKeywordLower) > -1 || clientInfo.ipAddress.toLowerCase().indexOf(searchKeywordLower) > -1 || clientInfo.macAddress.toLowerCase().indexOf(searchKeywordLower) > -1;
            }
          }

          if (filterParams.wirelessap && data.type === 'WIRELESSAP') {
            const trafficFlag = filterParams.wirelessap.traffic;
            const sortedWirelessap = cloneDeep(this.sortedWirelessapDatas[trafficFlag]);
            const topNWirelessap = filterParams.wirelessap.align === 'DESC' ? sortedWirelessap.slice(0, filterParams.wirelessap.limit) : sortedWirelessap.reverse().slice(0, filterParams.wirelessap.limit);
            const topN = topNWirelessap.indexOf(data.treeKey);
            const trafficInfo = trafficFlag === 'trafficIn' ? data.trafficInRscInfo : data.trafficOutRscInfo;
            wirelessapMatched = topN > -1 && !isNil(trafficInfo) && !isNil(trafficInfo.rscValue);
            if (wirelessapMatched) {
              topNData = {
                align: filterParams.wirelessap.align === 'DESC' ? 'Top' : 'Bottom',
                topN: topN + 1,
                value: trafficInfo.rscValue,
                unit: trafficInfo.rscUnit,
              };
            }
          }

          if (filterParams.client && data.type === 'CLIENT') {
            const trafficFlag = filterParams.client.traffic;
            const sortedClient = cloneDeep(this.sortedClientDatas[trafficFlag]);
            const topNClient = filterParams.client.align === 'DESC' ? sortedClient.slice(0, filterParams.client.limit) : sortedClient.reverse().slice(0, filterParams.client.limit);
            const topN = topNClient.indexOf(data.treeKey);
            const trafficValue = trafficFlag === 'trafficIn' ? data.clientInfo.trafficBpsIn : data.clientInfo.trafficBpsOut;
            clientMatched = topN > -1 && !isNil(trafficValue);
            if (clientMatched) {
              topNData = {
                align: filterParams.client.align === 'DESC' ? 'Top' : 'Bottom',
                topN: topN + 1,
                value: trafficValue,
                unit: 'bps',
              };
            }
          }

          if (filterParams.eventlevel && data.type !== 'CLIENT') {
            eventlevelMatched = data.eventlevelId ? filterParams.eventlevel.indexOf(data.eventlevelId) > -1 : false;
          }

          let highlightFlag = false;
          if (data.type === 'AP_CONTROLLER') {
            // AP 또는 접속자 필터링 조건일 경우, 컨트롤러는 무조건 표현되지 않는다.
            highlightFlag = searchMatched || eventlevelMatched;
          } else if (data.type === 'WIRELESSAP') {
            // 접속자 필터링 조건일 경우, AP는 무조건 표현되지 않는다.
            highlightFlag = searchMatched || wirelessapMatched || eventlevelMatched;
          } else {
            // AP 또는 이벤트등급 필터링 조건일 경우, 접속자는 무조건 표현되지 않는다.
            highlightFlag = searchMatched || clientMatched;
          }
          return { highlightFlag, topNData };
        };

        const expandFunc = (d) => {
          const filtered = filterFunc(d);
          d.isHighlighted = filtered.highlightFlag;
          d.data.topNData = filtered.topNData;
          const children = d.children || d.collapsedChildren;

          if (children) {
            d.existHighlightedTarget = false;
            children.forEach((child) => expandFunc(child));
            if (d.existHighlightedTarget) { // 현재 node expand
              if (d.parent) {
                d.parent.existHighlightedTarget = true; // 부모 node expand
              }
              d.children = d.children || d.collapsedChildren;
            }
          }

          if (d.isHighlighted && d.parent) {
            if (d.data.topNData) {
              this.showTopNFlag = true;
            }
            if (d.parent) {
              d.parent.existHighlightedTarget = true; // 부모 node expand
            }
          }
        };
        // root를 시작점으로 모든 node에 대해 검색 필터 조건에 부합하는지 판별, 부합되면 node expand 처리
        expandFunc(this.root);
        this.drawMap(this.root);

        d3.selectAll('.node')
          .classed('element--active', (d) => d.isHighlighted)
          .classed('element--inactive', (d) => !d.isHighlighted)
          .on('mouseover', (d) => this.mouseoverNode(d, tooltipDiv, true))
          .on('mouseout', () => this.mouseoutNode(tooltipDiv, true));
        d3.selectAll('.text')
          .classed('element--active', (d) => d.isHighlighted)
          .classed('element--inactive', (d) => !d.isHighlighted);
        d3.selectAll('.text-topn')
          .classed('text-topn--active', (d) => !isNil(d.data.topNData))
          .classed('text-topn--inactive', (d) => isNil(d.data.topNData))
          .text((d) => {
            if (!isNil(d.data.topNData)) {
              const convertedVal = this.convertValueByUnit({ rscValue: d.data.topNData.value, rscUnit: d.data.topNData.unit });
              return `(${d.data.topNData.align} ${d.data.topNData.topN}. ${convertedVal})`;
            }
            return '';
          });
        d3.selectAll('path.link')
          .classed('element--active', false)
          .classed('element--inactive', true);
      }
    },
    /**
     * 검색 필터 조건 별 params 설정, 필터 측면 라벨 표현
     * @author jeee12
     * @return {[type]} [description]
     */
    getFilterParams() {
      const filterLabel = [];
      const filterParams = {};
      if (this.wirelessapFilterInfo.active) {
        filterParams.wirelessap = {
          traffic: this.wirelessapFilterInfo.traffic,
          align: this.wirelessapFilterInfo.align,
          limit: this.wirelessapFilterInfo.limit,
        };
        filterLabel.push({
          key: 'AP',
          label: 'AP',
          value: `${filterParams.wirelessap.traffic === 'trafficIn' ? '트래픽 IN' : '트래픽 OUT'} ${filterParams.wirelessap.align === 'DESC' ? ' Top' : ' Bottom'} ${filterParams.wirelessap.limit} `,
        });
      }
      if (this.clientFilterInfo.active) {
        filterParams.client = {
          traffic: this.clientFilterInfo.traffic,
          align: this.clientFilterInfo.align,
          limit: this.clientFilterInfo.limit,
        };
        filterLabel.push({
          key: 'CLIENT',
          label: '접속자',
          value: `${filterParams.client.traffic === 'trafficIn' ? '트래픽 IN' : '트래픽 OUT'} ${filterParams.client.align === 'DESC' ? ' Top' : ' Bottom'} ${filterParams.client.limit} `,
        });
      }
      if (this.eventlevelFilterInfo.active && this.eventlevelFilterInfo.eventlevelIds && this.eventlevelFilterInfo.eventlevelIds.length > 0) {
        filterParams.eventlevel = this.eventlevelFilterInfo.eventlevelIds;
        let labelValue = '';
        filterParams.eventlevel.forEach((e, idx) => {
          if (idx > 0) {
            labelValue += ', ';
          }
          labelValue += `${this.eventlevelInfo[e].eventlevelName}`;
        });
        filterLabel.push({
          key: 'EVENTLEVELID',
          label: '이벤트 등급',
          value: labelValue,
        });
      }
      this.filterLabel = filterLabel;
      return filterParams;
    },
  },
};
</script>
<style lang="scss">
.full-f-chart.wirelessmap-wrapper {
  position: relative;
  height: 100%;
  padding: 0px;
  margin: 0px;

  .search-area {
    position: absolute;
    left: 0px;
    padding: 15px;
    z-index: 1;
  }
  .text-topn--active {
    display: block;
  }
  .text-topn--inactive {
    display: none;
  }
  .element--active {
    opacity: 1;
  }
  .element--inactive {
    opacity: 0.3;
  }
  div.wirelessmap-tooltip {
    position: absolute;
    visibility: hidden; // 마우스 오버 시에만 보이도록 처리
    padding: 5px 10px;
    font-size: 12px;
    background: #FFF;
    border: 1px solid #e4e5e6;
    border-left-width: 5px;
    border-radius: 5px;
    pointer-events: none;

    .label {
      font-weight: 500;
      color: #3b3c40;
      padding: 0 3px 0 10px !important
    }
    .value {
      color: #5077CF;
    }
  }

  .search-input {
    input {
      box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      transition: width .3s;
    }
  }

  .el-button--default {
    border-color: #dcdcdc;
    &:hover,
    &.selected {
      z-index: 1;
      color: #5077CF;
    }
  }

  .el-button--primary {
    background-color: #6184d2;
    border: 1px solid #6184d2;
    &:hover {
      background-color: #5971a7;
      border: 1px solid #5971a7;
    }
  }

  .filter-info {
    position: relative;
    margin-lefT: 7px;
    border-radius: 4px;
    padding: 8px 10px;
    background: #f9f9f9;
    font-size: 12px;

    &:before {
      content: "";
      width: 0px;
      height: 0px;
      position: absolute;
      border-left: 5px solid transparent;
      border-right: 5px solid #f9f9f9;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      left: -10px;
      top: 8px;
    }

    .item {
      &:not(:last-child) {
        margin-right: 10px;
      }
      .label {
        font-weight: 500;
        color: #5077CF;
        padding: 0 3px 0 10px !important
      }
      .value {
        color: #707177;
      }
    }
  }

  div.btn-list {
    position: absolute;
    right: 0;
    margin: 15px;
    display: flex;
    flex-direction: column;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
    border-radius: 4px;

    button {
      border-radius: 0;
      margin-top: -1px;

      &:first-child {
        border-radius: 4px 4px 0 0;
      }
      &:last-child {
        border-radius: 0 0 4px 4px;
      }

      .fa, .fas, .far, .fal, .fad, .fab {
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/performance/node/wireless-map/components/WirelessMapView.vue